import assetPath from '/app/packages/lebenslauf/articles/src/assets/erfolgreicher-wiedereinstieg-und-berufliche-neuorientierung-tipps-und-strategien.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')